import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AppRoutes } from '@shared/constants/routes.enum';
import { UserRole } from '../../domain/models/authenticated-user.model';
import { AuthStore } from '../store/auth.store';

export function roleGuard(allowedRoles: readonly UserRole[]): CanActivateFn {
  return () => {
    const user = inject(AuthStore).user();
    if (user?.accountRealm !== 'administration') return inject(Router).createUrlTree([AppRoutes.AccessDenied]);
    const role = user.role;
    if (role === UserRole.Developer) return true;
    return role && allowedRoles.includes(role) ? true : inject(Router).createUrlTree([AppRoutes.AccessDenied]);
  };
}
